const TYPES = {
  MEMBER: 'member',
  ARRAY: 'array',
  OBJECT: 'object',
  STRING: 'string',
  NUMBER: 'number',
  ENUM: 'enum',
  SELECT: 'select',
};

export default TYPES;



/** WEBPACK FOOTER **
 ** ./src/types.js
 **/